export default "__VITE_ASSET__nNQh50fM__"